import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { Formik, Form, Field } from 'formik';

import { updateBlockInfo } from '~/api';

import { Button } from '~/components/_layouts/forms/styles';
import Dialog from '~/components/Dialog';
import {
  SDialogTitle,
  ActionButtonSection,
  defaultFieldProps,
} from '~/components/Dialog/styles';
import Loading from '~/components/Loading';

export default function EditWorkoutDialog({
  isOpen,
  setIsOpen,
  block,
  refreshBlocks,
}) {
  const [isLoading, setIsLoading] = useState(false);

  const handleEmptyNumbers = (valuesToUpdate) => {
    if (valuesToUpdate.series === '') valuesToUpdate.series = null;
    if (valuesToUpdate.reps === '') valuesToUpdate.reps = null;
  };

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      handleEmptyNumbers(values);

      await updateBlockInfo(block.id, values);
      toast.success('Bloco alterado com sucesso !');

      refreshBlocks();
    } catch (error) {
      toast.error('Ops, não foi possivel alterar este bloco!');
    } finally {
      setIsLoading(false);
      setIsOpen(false);
    }
  };

  const getUpdatableFields = () => {
    const { name, series, reps } = block;
    return { name, series, reps };
  };

  return (
    <Dialog open={isOpen}>
      <SDialogTitle>Alterar bloco</SDialogTitle>
      <Formik
        enableReinitialize
        initialValues={getUpdatableFields()}
        onSubmit={handleSubmit}
      >
        <Form>
          <div>
            <Field
              name="name"
              label="Nome do bloco"
              required
              {...defaultFieldProps}
            />
            <Field
              name="series"
              label="Séries"
              type="number"
              {...defaultFieldProps}
            />
            <Field
              name="reps"
              label="Repetições"
              type="number"
              {...defaultFieldProps}
            />
          </div>
          <ActionButtonSection>
            <Button
              disabled={isLoading}
              type="button"
              cancelButton
              onClick={() => setIsOpen(false)}
            >
              Cancelar
            </Button>
            <Button disabled={isLoading} type="submit">
              Alterar
              {isLoading && <Loading buttonLoading />}
            </Button>
          </ActionButtonSection>
        </Form>
      </Formik>
    </Dialog>
  );
}

EditWorkoutDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  block: PropTypes.object.isRequired,
  refreshBlocks: PropTypes.func.isRequired,
};
